const picture = (name = "picture", label = "Image") => ({
  label,
  name,
  widget: "object",
  collapsed: true,
  fields: [
    {
      label: "Image",
      name: "image",
      widget: "image",
      default: "",
      required: true,
    },
    {
      name: "caption",
      widget: "string",
      label: "Caption",
      description: "What is the caption for this image?",
      required: false,
    },
    {
      name: "art_h",
      widget: "number",
      label: "Art Direction horizontal position (%).",
      description:
        "This helps when an image is cropped to fit on smaller screens. The % indicates where on the image the centre should be. If blank, will centre at 50%.",
      default: 50,
      value_type: "int",
      min: 0,
      max: 100,
      step: 5,
      required: false,
    },
    {
      name: "art_v",
      widget: "number",
      label: "Art Direction vertical position (%).",
      description:
        "This helps when an image is cropped to fit on smaller screens. The % indicates where on the image the centre should be. If blank, will centre at 50%.",
      default: 50,
      value_type: "int",
      min: 0,
      max: 100,
      step: 5,
      required: false,
    },
  ],
});

export default picture;
